import {
    APP_INITIALIZER,
    ApplicationConfig,
    importProvidersFrom,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HttpBackend, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import packageJson from 'package.json';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { ModalModule } from 'ngx-bootstrap/modal';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { NewLinePipe } from '@sb-tools/typescript/pipes/new-line.pipe';
import { ReplaceEmojisPipe } from '@sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { SignalRService } from './core/services/signalR.service';
import { LinkyPipe } from 'ngx-linky';
import { HttpLinkPipe } from '@sb-tools/typescript/pipes/ticket/http-link.pipe';
import { EncodeHtmlSymbolsPipe } from '@sb-tools/typescript/pipes/encode-html-symbols.pipe';
import { QuillHelperService } from '@sb-tools/typescript/services/quill/quill-helper.service';

export function HttpLoaderFactory(http: HttpBackend) {
    return new MultiTranslateHttpLoader(http, [
        { prefix: '/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-tools/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-modules/Frontend-Document-Viewer-Module/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-modules/Frontend-User-Avatar-Module/assets/i18n/', suffix: '.json?' + packageJson.version },
    ]);
}

function initQuill(quillHelperService: QuillHelperService) {
    return () => quillHelperService.initQuillRegisters();
}

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    // Change this to your upload POST address:
    // url: 'https://httpbin.org/post',
    maxFilesize: 50,
    acceptedFiles: 'image/*',
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptors([apiInterceptor, errorInterceptor])),
        {
            provide: APP_INITIALIZER,
            useFactory: initQuill,
            multi: true,
            deps: [QuillHelperService],
        },
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpBackend],
                },
            }),
            SimpleNotificationsModule.forRoot({
                position: ['bottom', 'right'],
                timeOut: 3000,
                lastOnBottom: true,
                showProgressBar: true,
                pauseOnHover: true,
            }),
            ModalModule.forRoot(),
        ),
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG,
        },
        ReplaceEmojisPipe,
        SignalRService,
        LinkyPipe,
        HttpLinkPipe,
        NewLinePipe,
        EncodeHtmlSymbolsPipe,
    ],
};
